export enum memberTypes {
  PROFILE = 'profile',
  GROUP = 'group',
}
